import { render } from "./identify.vue?vue&type=template&id=83368e3c"
import script from "./identify.vue?vue&type=script&lang=js"
export * from "./identify.vue?vue&type=script&lang=js"

import "./identify.vue?vue&type=style&index=0&id=83368e3c&lang=css"
script.render = render

export default script